import { createContext } from "react";

// Lets `ItemActions` read the owning `Item`'s `size` without a prop-drilling requirement on
// every consumer. Split into its own file (not exported from Item.tsx) to avoid a circular
// import between Item.tsx and ItemActions.tsx.
export const ItemSizeContext = createContext<"default" | "sm">("default");
